import { render, staticRenderFns } from "./UnlockableItem.vue?vue&type=template&id=78011d52&scoped=true&"
import script from "./UnlockableItem.vue?vue&type=script&lang=js&"
export * from "./UnlockableItem.vue?vue&type=script&lang=js&"
import style0 from "./UnlockableItem.vue?vue&type=style&index=0&id=78011d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78011d52",
  null
  
)

export default component.exports